const FOLLOW_UP_TYPE = {
  CALL: { value: 'CALL', label: 'Call' },
  MESSAGE: { value: 'MESSAGE', label: 'Message' }
};

const FOLLOW_UP_TYPES = Object.values(FOLLOW_UP_TYPE);

export { FOLLOW_UP_TYPE, FOLLOW_UP_TYPES };
